export const isChatOpen = (state)=>{
    return state.isChatOpen
}